import { useMutation } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiSavedReportFormObject } from "../saved-reports-types"

export function useSaveReportMutation() {
  const apiClient = useApiClient()

  const mutation = useMutation(
    ['save-report'],
    async (savedReport: TApiSavedReportFormObject) => {

      const response = await apiClient.post('/saved_reports', {
        savedReport: savedReport
      })

      if (!response.ok) {
        throw response.errors
      }

      return response.savedReport
    }
 )

  return mutation
}